import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../../app/app.service';
import { TrainingPreviewVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-start-training-details',
  templateUrl: './start-training-details.component.html',
  styleUrls: ['./start-training-details.component.scss']
})
export class StartTrainingDetailsComponent implements OnInit {

  TrainingId: number;
  userId: number;
  username:string
  training:string
  previewInfo :TrainingPreviewVM
  constructor(private _route: ActivatedRoute, private _dialog: MatDialog,private _router: Router,
    private _appService: AppService, private _trainingService: TrainingService,) { }

  ngOnInit() {
    this._appService.setPageTitle('Setup Training Questions');
    this.userId = Number(this._route.snapshot.params.id);
    this.TrainingId = Number(this._route.snapshot.params.id2);
    this.GetUserNameAndTrainingName();
    console.log("info", this.userId, this.TrainingId)
  }

  StartTraining_(){
      this._trainingService.StartNewTrainingSession(this.TrainingId).subscribe(res=>{
        console.log("result_start", res)
        if(res.m_Item1>0){
            this._router.navigate(['training-session', res.m_Item1,this.TrainingId]);
        }
      })
  }

  GetUserNameAndTrainingName(){
    this._trainingService.GetSelectedTrainingPreviewInfo(this.TrainingId, this.userId).subscribe(res=>{
      this.previewInfo =res;
      this.username=this.previewInfo.UserName;
      this.training = this.previewInfo.TrainingType + " - " + this.previewInfo.TrainingName; 
    })
  }

}
